<template>
  <div v-if="menuEventYn">
    <!-- modal -->
    <div class="dimed wrap">
      <div class="layer">
        <!-- header -->
        <div class="layer__header">
          <div class="lyr-title">{{ $t('Modal.MenuEvent.msg1') }}</div>
          <div class="ft-point">{{ $t('Modal.MenuEvent.msg2') }}</div>
          <div class="lyr-txt">{{ $t('Modal.MenuEvent.msg3') }}</div>
        </div>
        <!-- //header -->

        <!-- body -->
        <div class="menu__body--box" id="scrollArea">
          <!-- 스크롤: 아래 요소에 scroll-area 클래스 추가 -->
          <div class="menu__event scroll-area">
            <!-- one item -->

            <div
              v-for="item in excludeList"
              :key="item"
              @click="menuAdd(item)"
              class="touchbox touchbox--land btn-anim"
              :class="{on: menuList.indexOf(item) != -1}"
            >
              <span class="ico-checked">checked</span>
              <div class="row__img">
                <img :src="item.SUB_ITEM_IMG_FILE_URL" alt="" @error="replaceToDefaultImg" />
              </div>
              <div class="row__txt">
                <div class="ellipsis-m">
                  <span class="ft--xsm">{{ item.DIS_ITEM_NM }}</span>
                </div>
                <span class="ft--lg ft--bold">{{ $displayUprc($detailUprc(item)) }}</span>
              </div>
            </div>

            <!-- //one item -->
          </div>
        </div>
        <!-- //body -->

        <div class="btn-area">
          <button class="btn-arr-u btn-anim" @mouseup="scrollMove(-100)">위로</button>
          <button class="btn-arr-d btn-anim" @mouseup="scrollMove(100)">아래로</button>
        </div>

        <!-- footer -->
        <div class="menu__footer">
          <dl class="basic-price">
            <dt>{{ $t('Modal.MenuEvent.msg4') }}</dt>
            <dd :class="[menuList.length == 0 ? 'ft--dgray' : 'ft--point']">{{ $displayUprc(totAmt) }}</dd>
          </dl>
        </div>
        <!-- //footer -->

        <div class="layer__button">
          <button class="btn btn--cancel btn-anim" @mouseup="close()">{{ $t('Modal.MenuEvent.msg5') }}</button>
          <button class="btn btn--submit btn-anim" :disabled="menuList.length == 0" @mouseup="basketAdd()">
            {{ $t('Modal.MenuEvent.msg6') }}
          </button>
        </div>
      </div>
      <!-- //modal -->
    </div>
  </div>
</template>
<script>
import chargeHelper from '@/js/common/chargeHelper.js';
import _ from 'lodash';

import audioHelper from '@/js/common/audioHelper.js';

export default {
  name: 'menuEvent',
  data() {
    return {
      menuList: [],
      darkModeYn: this.$store.getters.getDarkModeYn,
      recomItemList:
        this.$store.getters.getPosConfig.posConfig.templateNo == 'F'
          ? this.$store.getters.getRecommendItem.filter((item) => item.CLAS_L_CD == (this.$store.getters.getOrderType == 1 ? '001' : '002'))
          : this.$store.getters.getRecommendItem,
      currUnitText: this.$store.getters.getCurrUnitText,
    };
  },
  updated() {
    this.$showButtonAnimation();
  },
  mounted() {
    if (this.$i18n.locale == 'jp') {
      this.recomItemList.forEach((item) => {
        item.DIS_ITEM_NM = item.DIS_ITEM_NM_JP;
      });
    } else if (this.$i18n.locale == 'ko') {
      this.recomItemList.forEach((item) => {
        item.DIS_ITEM_NM = item.DIS_ITEM_NM_KO;
      });
    } else if (this.$i18n.locale == 'en') {
      this.recomItemList.forEach((item) => {
        item.DIS_ITEM_NM = item.DIS_ITEM_NM_EN;
      });
    } else if (this.$i18n.locale == 'cn') {
      this.recomItemList.forEach((item) => {
        item.DIS_ITEM_NM = item.DIS_ITEM_NM_CN;
      });
    } else if (this.$i18n.locale == 'tw') {
      this.recomItemList.forEach((item) => {
        item.DIS_ITEM_NM = item.DIS_ITEM_NM_TW;
      });
    }
  },
  props: {
    menuEventYn: Boolean,
    baskets: Array,
  },
  watch: {
    menuEventYn: function (val) {
      this.menuList = [];

      try {
        // 20230407 HSSHIN Audio 재생
        if (val) {
          audioHelper.playAudio('00106', this.$i18n.locale, this.$store.getters.getPosConfig.posConfig.useVoiceSupport);
        } else {
          audioHelper.stopAudio();
        }
      } catch (ex) {
        console.error(ex);
      }
    },
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
  },
  methods: {
    replaceToDefaultImg(e) {
      // 상품 이미지 로딩 실패 시 기본 이미지 표시
      e.target.src = require('@/assets/images/common/no-image.png');
    },
    close() {
      this.$logInfo(`Payment Start Unselect Tran : ${JSON.stringify(this.$store.getters.getBaskets)}`);
      this.$router.replace('/user/payment');
    },
    basketAdd() {
      let itemList = new Array();
      const posConfig = this.$store.getters.getPosConfig.posConfig;
      const receiptDiscount = this.$store.getters.getReceiptDiscount;

      let orgBaskets = _.cloneDeep(this.$store.getters.getOrgBaskets);

      this.menuList.forEach((menu) => {
        menu.OPTIONITEM = [];
        menu.SALES_QTY = 1;
        orgBaskets.push(menu);
      });

      this.$store.dispatch('setOrgBaskets', orgBaskets);

      this.baskets.forEach((basket) => {
        let optionitem = new Array();
        basket.OPTIONITEM.forEach((opt) => {
          let option = {
            SALES_QTY: basket.SALES_QTY,
            ITEM_CD: opt.ITEM_CD,
            ITEM_NM: opt.ITEM_NM,
            ITEM_ORG_NM: opt.ITEM_ORG_NM,
            ITEM_PARENT_NM: opt.ITEM_PARENT_NM,
            CLAS_L_CD: opt.CLAS_L_CD,
            CLAS_M_CD: opt.CLAS_M_CD,
            CLAS_S_CD: opt.CLAS_S_CD,
            TAX_FLG_CD: opt.TAX_FLG_CD,
            TAX_RDC_FLG_CD: opt.TAX_RDC_FLG_CD,
            NRML_UPRC: opt.NRML_UPRC,
            SALE_UPRC: opt.SALE_UPRC,
            SALES_UPRC: opt.SALES_UPRC,
            ORG_SALES_UPRC: opt.SALES_UPRC,
            DC_ABLE_YN: opt.DC_ABLE_YN,
            DC_AMT: opt.DC_AMT,
            SALES_AMT: opt.SALES_AMT,
            VAT_AMT: opt.VAT_AMT,
            VAT_RATE: opt.VAT_RATE,
            SVC_AMT: opt.SVC_AMT,
            SUPY_UPRC: opt.SUPY_UPRC,
            MG_RATE: opt.MG_RATE,
          };

          // 행사 정보 (옵션)
          let eventItem = [];
          if (opt.EVNT_ITEM_CD != '' && opt.EVNT_ITEM_CD != null) {
            let event = {
              EVNT_CD: opt.EVNT_CD,
              EVNT_NM: opt.EVNT_NM,
              EVNT_KEY_TYPE: opt.EVNT_KIND_CD,
              EVNT_FLG_CD: opt.EVNT_FLG_CD,
              DC_FLG_CD: opt.EVNT_DC_FLG_CD,
              DC_ITEM_QTY: basket.SALES_QTY,
              DC_AMT: opt.EVNT_DC_AMT,
              EVNT_ITEM_CD: opt.EVNT_ITEM_CD,
              DC_RATE: opt.EVNT_DC_AMT,
              EVNT_FROM_DATE: opt.EVNT_FROM_DATE,
              EVNT_END_DATE: opt.EVNT_END_DATE,
              TIME_SALE_YN: opt.TIME_SALE_YN,
              TIME_SALE_FROM_TIME: opt.TIME_SALE_FROM_TIME,
              TIME_SALE_END_TIME: opt.TIME_SALE_END_TIME,
            };
            eventItem.push(event);
          }

          option.EVENTITEM = eventItem;

          optionitem.push(option);
        });

        let itemName;
        if (posConfig.defaultLanguage == 'KO') itemName = basket.DIS_ITEM_NM_KO;
        else if (posConfig.defaultLanguage == 'JP') itemName = basket.DIS_ITEM_NM_JP;
        else if (posConfig.defaultLanguage == 'EN') itemName = basket.DIS_ITEM_NM_EN;
        else if (posConfig.defaultLanguage == 'CH') itemName = basket.DIS_ITEM_NM_CN;
        else if (posConfig.defaultLanguage == 'TW') itemName = basket.DIS_ITEM_NM_TW;

        // 행사 정보
        let eventItem = [];
        if (basket.EVNT_ITEM_CD != '' && basket.EVNT_ITEM_CD != null) {
          let event = {
            EVNT_CD: basket.EVNT_CD,
            EVNT_NM: basket.EVNT_NM,
            EVNT_KEY_TYPE: basket.EVNT_KIND_CD,
            EVNT_FLG_CD: basket.EVNT_FLG_CD,
            DC_FLG_CD: basket.EVNT_DC_FLG_CD,
            DC_ITEM_QTY: basket.SALES_QTY,
            DC_AMT: basket.EVNT_DC_AMT,
            EVNT_ITEM_CD: basket.EVNT_ITEM_CD,
            DC_RATE: basket.EVNT_DC_AMT,
            EVNT_FROM_DATE: basket.EVNT_FROM_DATE,
            EVNT_END_DATE: basket.EVNT_END_DATE,
            TIME_SALE_YN: basket.TIME_SALE_YN,
            TIME_SALE_FROM_TIME: basket.TIME_SALE_FROM_TIME,
            TIME_SALE_END_TIME: basket.TIME_SALE_END_TIME,
          };
          eventItem.push(event);
        }

        let item = {
          ITEM_CD: basket.DIS_ITEM_CD,
          ITEM_NM: basket.DIS_ITEM_NM,
          ORG_ITEM_NM: itemName,
          CLAS_L_CD: basket.CLAS_L_CD,
          CLAS_M_CD: basket.CLAS_M_CD,
          CLAS_S_CD: basket.CLAS_S_CD,
          TAX_FLG_CD: basket.TAX_FLG_CD,
          TAX_RDC_FLG_CD: basket.TAX_RDC_FLG_CD,
          NRML_UPRC: basket.SALE_UPRC,
          SALES_QTY: basket.SALES_QTY,
          SALES_UPRC: basket.SALE_UPRC,
          ORG_SALES_UPRC: basket.SALE_UPRC,
          DC_ABLE_YN: basket.DC_ABLE_YN,
          DC_AMT: 0.0,
          SALES_AMT: 0,
          VAT_AMT: 0,
          VAT_RATE: basket.TAX_RATE,
          SVC_AMT: 0,
          SUPY_UPRC: basket.SUPY_UPRC,
          MG_RATE: basket.MG_RATE,
          OPTIONITEM: optionitem,
          EVENTITEM: eventItem,
        };

        itemList.push(item);
      });

      this.menuList.forEach((basket) => {
        let itemName2;
        if (posConfig.defaultLanguage == 'KO') itemName2 = basket.DIS_ITEM_NM_KO;
        else if (posConfig.defaultLanguage == 'JP') itemName2 = basket.DIS_ITEM_NM_JP;
        else if (posConfig.defaultLanguage == 'EN') itemName2 = basket.DIS_ITEM_NM_EN;
        else if (posConfig.defaultLanguage == 'CH') itemName2 = basket.DIS_ITEM_NM_CN;
        else if (posConfig.defaultLanguage == 'TW') itemName2 = basket.DIS_ITEM_NM_TW;

        // 행사 정보
        let eventItem = new Array();
        if (basket.EVNT_ITEM_CD != '' && basket.EVNT_ITEM_CD != null) {
          let event = {
            EVNT_CD: basket.EVNT_CD,
            EVNT_NM: basket.EVNT_NM,
            EVNT_KEY_TYPE: basket.EVNT_KIND_CD,
            EVNT_FLG_CD: basket.EVNT_FLG_CD,
            DC_FLG_CD: basket.EVNT_DC_FLG_CD,
            DC_ITEM_QTY: basket.SALES_QTY,
            DC_AMT: basket.EVNT_DC_AMT,
            EVNT_ITEM_CD: basket.EVNT_ITEM_CD,
            DC_RATE: basket.EVNT_DC_AMT,
            EVNT_FROM_DATE: basket.EVNT_FROM_DATE,
            EVNT_END_DATE: basket.EVNT_END_DATE,
            TIME_SALE_YN: basket.TIME_SALE_YN,
            TIME_SALE_FROM_TIME: basket.TIME_SALE_FROM_TIME,
            TIME_SALE_END_TIME: basket.TIME_SALE_END_TIME,
          };
          eventItem.push(event);
        }

        let item = {
          ITEM_CD: basket.DIS_ITEM_CD,
          ITEM_NM: basket.DIS_ITEM_NM,
          ORG_ITEM_NM: itemName2,
          CLAS_L_CD: basket.CLAS_L_CD,
          CLAS_M_CD: basket.CLAS_M_CD,
          CLAS_S_CD: basket.CLAS_S_CD,
          TAX_FLG_CD: basket.TAX_FLG_CD,
          TAX_RDC_FLG_CD: basket.TAX_RDC_FLG_CD,
          NRML_UPRC: basket.SALE_UPRC,
          SALES_QTY: 1,
          SALES_UPRC: basket.SALE_UPRC,
          ORG_SALES_UPRC: basket.SALE_UPRC,
          DC_ABLE_YN: basket.DC_ABLE_YN,
          DC_AMT: 0.0,
          SALES_AMT: 0,
          VAT_AMT: 0,
          VAT_RATE: basket.TAX_RATE,
          SVC_AMT: 0,
          OPTIONITEM: [],
          SUPY_UPRC: basket.SUPY_UPRC,
          MG_RATE: basket.MG_RATE,
          EVENTITEM: eventItem,
        };
        itemList.push(item);
      });

      let jsonObj = {
        ITEMLIST: itemList,
        EXTRA: {
          ORDER_TYPE: this.$store.getters.getOrderType,
        },
      };

      let tranObj = _.cloneDeep(jsonObj);

      // 상품 가격 계산 (상품할인 행사 포함)
      chargeHelper.calculate(tranObj, posConfig);

      // 영수증 금액 할인 행사 계산
      if (receiptDiscount != null) {
        chargeHelper.receipt(tranObj, posConfig, receiptDiscount);
      }

      tranObj.ITEMLIST.forEach((basket) => {
        let sum = 0;
        basket.OPTIONITEM.forEach((opt) => {
          sum += opt.SALES_UPRC;
        });
        basket.TOTAL_UPRC = (basket.SALES_UPRC + sum) * basket.SALES_QTY;
      });

      this.$logInfo(`Payment Start Select Tran : ${JSON.stringify(tranObj)}`);
      this.$store.dispatch('setBaskets', tranObj);
      this.$router.replace('/user/payment');
    },
    menuAdd(item) {
      let num = this.menuList.indexOf(item);
      if (num < 0) {
        this.menuList.push(item);
      } else {
        this.menuList.splice(num, 1);
      }
    },
    scrollMove(val) {
      var scroll = document.getElementById('scrollArea');
      scroll.scrollTop += val;
    },
  },
  computed: {
    darkMode: function () {
      return this.$store.getters.getDarkModeYn;
    },
    totAmt() {
      let sum = 0;
      this.menuList.forEach((menu) => {
        sum += this.$detailUprc(menu);
      });
      return sum;
    },
    excludeList() {
      let excludeList = new Array();
      this.recomItemList.forEach((item) => {
        excludeList.push(item);
        this.baskets.forEach((bas) => {
          if (item.DIS_ITEM_CD === bas.DIS_ITEM_CD) excludeList.pop();
        });
      });

      return excludeList;
    },
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/pages/menu.css" scoped></style>
<style src="@/assets/css/user/pages/touchbox.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style src="@/assets/css/user/dark/menu-dark.css" scoped></style>
<style src="@/assets/css/user/dark/touchbox-dark.css" scoped></style>
<style scoped>
.dark .layer,
.layer {
  padding: 3.6vh 3vw 8vh;
}

.menu__body--box {
  padding: 1.7vh 0;
}

.menu__event {
  display: block;
}

.menu__event .touchbox.touchbox--land {
  float: left;
  width: 44%;
  justify-content: space-between;
  margin-left: 4%;
  padding: 0.8em;
}

.row__txt {
  padding: 0.5vh 0;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 7.5em;
}

.row__txt .ellipsis-m {
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  height: 3em;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  min-width: 10vw;
}

.row__txt .ellipsis-m .ft--xsm {
  display: block;
  width: 100%;
  height: auto;
  max-height: 3em;
  display: block;
  word-wrap: break-word;
  word-break: keep-all;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
}

.row__img img {
  height: 100%;
}

.ico-checked {
  display: none;
}

.on > .ico-checked {
  display: block;
  background: url('@/assets/images/user/ico-check.png') no-repeat;
  background-size: 100% auto;
}
</style>
